import { WorldStore } from "../../store/WorldStore.js";
import { EventBus } from "../EventBus.js";

/**
 * Route a changed Ink contract variable to the engine state it controls (N05).
 *
 * Called from NarrativeManager.observeVariable() on every Ink variable change.
 * Authors may use either an external function call (`set_hostile("npc_id")`)
 * or the observed variable (`~ hostile = true`) — this router handles the
 * variable path for the three contract vars that trigger engine side-effects.
 *
 * Note: the `hostile` and `shop_open` variable paths cannot carry an NPC ID
 * (unlike the external-function paths). Downstream handlers receive an empty
 * npcId string and should resolve the active NPC from their own context.
 */
export function routeContractVariable(name: string, value: unknown): void {
  switch (name) {
    case "boss_dead":
      if (value === true) WorldStore.setBossDead();
      break;

    case "hostile":
      if (value === true) EventBus.emit("enemy:set_hostile", { npcId: "" });
      break;

    case "shop_open":
      if (value === true) EventBus.emit("narrative:open_shop", { npcId: "" });
      break;

    default:
      // W22: `light_<id>_off` per-map observed variables flow back into the
      // world store. Absolute setter — skips a no-op if the state already
      // matches. Unknown ids are harmless.
      if (name.startsWith("light_") && name.endsWith("_off")) {
        const lightId = name.slice("light_".length, -"_off".length);
        if (lightId.length > 0) WorldStore.setLightOff(lightId, value === true);
      }
      break;
  }
}
